import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardMedia,
  Chip,
} from "@mui/material";
import innovation from "../../assets/innovation.png";
import marketTrend from "../../assets/markettrend.png";
import marketShare from "../../assets/marketshare.png";

const FutureTrends = ({ stats }) => {
  function formatData(data) {
    const trends = data["Future Trends"]["Next 5 Years"];
    const trendsData = [
      {
        title: "Innovation",
        description: trends["Innovation"],
        imageUrl: innovation,
      },
      {
        title: "Market Trends",
        description: trends["Market Trends"],
        imageUrl: marketTrend,
      },
      {
        title: "Market Share",
        description: trends["Market Share"],
        imageUrl: marketShare,
      },
    ];
    return trendsData;
  }

  const formattedData = formatData(stats);

  return (
    <Grid container spacing={2}>
      {formattedData.map((trend, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card
            sx={{
              position: "relative",
              boxShadow: "none",
              borderRadius: "16px",
              outline: 0,
            }}
          >
            <CardMedia
              component="img"
              height="300"
              image={trend.imageUrl}
              alt={trend.title}
            />
            <Chip
              label="Trends"
              sx={{
                position: "absolute",
                top: 16,
                left: 16,
                bgcolor: "green.main",
                color: "#fff",
              }}
            />
            <CardContent sx={{ position: "absolute", bottom: 12 }}>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                color={"#fff"}
              >
                {trend.title}
              </Typography>
              <Typography variant="subtitle2" color={"grey"}>
                {trend.description}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default FutureTrends;
